type PropTypes = {
  className?: string
}

const MailInviteIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="24"
        height="24"
        fill="white"
        fillOpacity="0.01"
      />
      <path d="M18.75 13.5L17.6894 14.5606L19.6254 16.5H13.5C12.7044 16.5 11.9413 16.8161 11.3787 17.3787C10.8161 17.9413 10.5 18.7044 10.5 19.5C10.5 20.2957 10.8161 21.0587 11.3787 21.6213C11.9413 22.1839 12.7044 22.5 13.5 22.5H15V21H13.5C13.1022 21 12.7206 20.842 12.4393 20.5607C12.158 20.2794 12 19.8978 12 19.5C12 19.1022 12.158 18.7206 12.4393 18.4393C12.7206 18.158 13.1022 18 13.5 18H19.6254L17.6884 19.9405L18.75 21L22.5 17.25L18.75 13.5Z" fill="#161616" />
      <path d="M7.5 16.5H3L2.99745 5.1798L11.573 11.1167C11.6985 11.2035 11.8474 11.25 12 11.25C12.1526 11.25 12.3015 11.2035 12.427 11.1167L21 5.18145V12H22.5V4.5C22.4995 4.10233 22.3413 3.72109 22.0601 3.43989C21.7789 3.15869 21.3977 3.0005 21 3H3C2.60263 3 2.2215 3.15767 1.94027 3.43841C1.65904 3.71915 1.5007 4.10001 1.5 4.49738V16.5C1.50052 16.8977 1.65872 17.2789 1.93991 17.5601C2.2211 17.8413 2.60233 17.9995 3 18H7.5V16.5ZM19.3489 4.5L12 9.58778L4.65105 4.5H19.3489Z" fill="#161616" />
    </svg>

  )
}

export default MailInviteIcon
